import { on } from "events";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import TimeMe from "timeme.js";

interface ElementTimerComponentProps {
  id: string;
  children: React.ReactNode;
  ref?: React.Ref<any>;
  syncDuration?: number; // in seconds
  // eslint-disable-next-line no-unused-vars
  onDurationChange?: (duration: number, change: number) => void;
}

export const ElementTimerComponent = forwardRef<any, ElementTimerComponentProps>(({ id, children, syncDuration, onDurationChange }: ElementTimerComponentProps, ref) => {
  const timerRef = React.useRef<any>(null);
  const previousTime = React.useRef<number>(0);
  
  const handleDurationChange = (time: number) => {
    const change = time - previousTime.current;
    previousTime.current = time;

    if(change == 0) {
      console.log("No change in time");
    }

    if(change > 0 && onDurationChange){
      onDurationChange(time, change);
    }
  }

  useEffect(() => {
    handleInitialise(id);

    return () => {
      handleDestroy(id);
    }
  }, [id]);

  useImperativeHandle(ref, () => {
    return {
      duration() {
        const duration = TimeMe.getTimeOnPageInSeconds(id);
        const change = duration - previousTime.current;
        previousTime.current = duration;
        return {
          duration,
          change
        }
      }
    };
  }, [id]);

  const handleInitialise = (id: string) => {
    TimeMe.initialize({
      currentPageName: id,
      idleTimeoutInSeconds: 30,
    });
    
    const duration = syncDuration || 30;
    timerRef.current = setInterval(() => {
      handleDurationChange(TimeMe.getTimeOnPageInSeconds(id));
    }, duration * 1000);

    TimeMe.startTimer(id);
  }

  const handleDestroy = (id: string) => {
    TimeMe.stopTimer(id);
    TimeMe.resetRecordedPageTime(id);

    if(timerRef.current) {
      clearInterval(timerRef.current);
    }
  }

  return <>{children}</>;
});

ElementTimerComponent.displayName = "ElementTimerComponent";